import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  card: {
    width: '100%'
  }
}));
